import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../../../environments/environment';

interface TagStateStyles {
    text: string;
    border: string;
    background: string;
    icon?: string;
}

export enum TagState {
    Default = 'default',
    Success = 'success',
    Pending = 'pending',
    Error = 'error'
}

export const StatusTagInfo: Record<string | TagState, { border: string; background: string; text: string, icon: string }> = {
    [TagState.Default]: {
        text: 'text-gray-700',
        border: 'border-gray-200',
        background: 'bg-gray-100',
        icon: 'dot-gray',
    },
    [TagState.Success]: {
        text: 'text-success-700',
        border: 'border-success-200',
        background: 'bg-success-50',
        icon: 'dot-green',
    },
    [TagState.Pending]: {
        text: 'text-warning-700',
        border: 'border-warning-200',
        background: 'bg-warning-50',
        icon: 'dot-orange',
    },
    [TagState.Error]: {
        text: 'text-red-700',
        border: 'border-red-200',
        background: 'bg-red-50',
        icon: 'dot-red',
    }
};

@Component({
    selector: 'glo-tag',
    imports: [CommonModule],
    templateUrl: './tag.component.html'
})
export class GloTagComponent {
    @Input() text: string = '';
    @Input() state: TagState | string = TagState.Default;
    @Input() showIcon: boolean = true;

    assetUrl = environment.assetBaseUrl
    
    stateStyles: { [key: string]: TagStateStyles } = StatusTagInfo;
}
